import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const NotificationBarDialog = ({ open, onClose, onIncidentCountUpdate }) => {
  useEffect(() => {
    if (typeof onIncidentCountUpdate === "function") {
      onIncidentCountUpdate(0);
    }
  }, [onIncidentCountUpdate]);

  return (
    <Dialog open={Boolean(open)} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Notifications</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2">
          No notifications available.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationBarDialog;

